// Suivi de conversion Google Ads (balise AW-18328377277).
// La balise de base est chargée dans public/index.html (window.gtag).
// On déclenche ici la conversion "Inscription" quand un compte est créé.

const SIGNUP_CONVERSION_SEND_TO = 'AW-18328377277/6qVbCMKf19EcEL2v06NE'

// Fenêtre pendant laquelle un compte est considéré comme "nouveau" après création
// (utile pour distinguer une inscription Google d'une reconnexion).
const NEW_ACCOUNT_WINDOW_MS = 2 * 60 * 1000

type GtagFn = (...args: any[]) => void

function getGtag(): GtagFn | null {
  const w = window as unknown as { gtag?: GtagFn }
  return typeof w.gtag === 'function' ? w.gtag : null
}

/**
 * Envoie la conversion "Inscription" à Google Ads.
 * Sans effet si la balise gtag n'est pas chargée (ex: bloquée par un ad-blocker).
 */
export function trackSignupConversion(): void {
  const gtag = getGtag()
  if (!gtag) return
  gtag('event', 'conversion', { send_to: SIGNUP_CONVERSION_SEND_TO })
}

/**
 * Déclenche la conversion pour une connexion OAuth (Google) uniquement si le
 * compte vient d'être créé, afin de ne pas compter les reconnexions.
 */
export function trackSignupConversionIfNewAccount(createdAt?: string | null): void {
  if (!createdAt) return
  const created = new Date(createdAt).getTime()
  if (Number.isNaN(created)) return
  if (Date.now() - created <= NEW_ACCOUNT_WINDOW_MS) {
    trackSignupConversion()
  }
}
